"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconThumbsDown = _interopRequireDefault(require("./IconThumbsDown"));
var IconThumbsUp = /*#__PURE__*/(0, _styledComponents.default)(_IconThumbsDown.default).withConfig({
  displayName: "IconThumbsUp",
  componentId: "c11n-8-107-0__sc-1ibwq0v-0"
})(["transform:scaleY(-1);"]);
var _default = IconThumbsUp;
exports.default = _default;